import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Editor from './components/Editor';
import Preview from './components/Preview';
import reportWebVitals from './reportWebVitals';
import store from './store';
import { Provider } from 'react-redux'
const router = createBrowserRouter([
  {
    path: '/',
    element: <Editor />
  },
  {
    path: '/preview',
    element: <Preview />
  }
])
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <RouterProvider router={router}>
    </RouterProvider>
  </Provider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
